import { defineComponent as _defineComponent } from 'vue'
import MainScreen from "./components/main-screen.vue";
import { provide, ref } from "vue";
import { TimeDataKey, useTimeData } from "@/components/time-data";


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props, { expose }) {
  expose();

provide(TimeDataKey, useTimeData());

const black = ref(window.self === window.top);

const __returned__ = { black, MainScreen, provide, ref, TimeDataKey, useTimeData }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})